export type FeatureKey = 'HR' | 'HRV' | 'LF' | 'HF';

export const FEATURE_KEYS: FeatureKey[] = ['HR', 'HRV', 'LF', 'HF'];
